module.exports = __webpack_public_path__ + "img/borescope_in_wall_led.248e1f6c.png";